import { render, staticRenderFns } from "./schoolOrgSearch.vue?vue&type=template&id=70e33e00&"
import script from "./schoolOrgSearch.vue?vue&type=script&lang=js&"
export * from "./schoolOrgSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports